export const StatusDot = ({ color }) => {
  return (
    <span
      style={{
        display: "inline-block",
        width: "12px",
        height: "12px",
        borderRadius: "50%",
        backgroundColor: color,
        // boxShadow: `0 0 6px ${color}`,
        marginLeft: "6px"
      }}
    />
  );
};